import { datetimeTransformFn } from "./datetime.transform";

export type DataTransformer = (data: unknown) => unknown;

export const transformFunctions: Record<string, DataTransformer> = {
	datetimeTransformFn,
};
